import { render, staticRenderFns } from "./AutoWidthOption.vue?vue&type=template&id=159d1542"
import script from "./AutoWidthOption.vue?vue&type=script&lang=js"
export * from "./AutoWidthOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports